<template>
  <div class="md-layout md-gutter-sm">
    <!-- Header -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content class="order-header">
          <div class="order-info-header">
            <h6>
              Order Number: <strong>{{ orderData.orderNumber }}</strong>
              <span
                v-if="orderData.countryCode"
                class="country-badge"
                :style="getCountryBadgeStyle(orderData.countryCode)"
                :title="getCountryName(orderData.countryCode)"
              >
                {{ getCountryFlag(orderData.countryCode) }} {{ orderData.countryCode }}
              </span>
              <span v-if="orderData.currency" class="currency-pill">
                {{ getCurrencySymbol(orderData.currency) }} {{ (orderData.currency || '').toUpperCase() }}
              </span>
            </h6>
            <h6>Order Date: <strong>{{ HumanReadableDateFormat(orderData.created_at) }}</strong></h6>
          </div>

          <div class="button-group">
            <button type="button" class="btn btn-success btn-sm" @click="openDeviceAllocationModal">Allocation QrCode</button>
            <button v-if="orderData && orderData.kidsOrderKidDetails" type="button" class="btn btn-info btn-sm" @click="openCustomizeDetailModal">Customize Detail</button>
            <button type="button" class="btn btn-warning btn-sm" @click="ByPassUserLogin(orderData.email, 'MDM')">Login MDM</button>
            <button type="button" class="btn btn-secondary btn-sm" @click="openQrModal">View QR Code</button>
            <button type="button" class="btn btn-primary btn-sm"
              @click="$router.push({ path: '/kid/review-request', query: { email: orderData.email, orderNumber: orderData.orderNumber }})">
              Request Review
            </button>
            <button type="button" class="btn btn-danger btn-sm" v-if="orderData.orderStatus != 'Delivered'"
              @click="clearData()" :disabled="isDisabled">
              Clear Data <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </button>
          </div>
        </md-card-content>
      </md-card>
    </div>


    <!-- Allocation QR Code Modal -->
    <md-dialog :md-active.sync="deviceAllocationModal">
      <md-dialog-title>Device Registration</md-dialog-title>
      <md-dialog-content>
        <div class="modal-details" v-if="orderData">
          <div class="qr-modal-container">
            <img :src="orderData.deviceAllotmentQrCode" class="qr-large" />
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="deviceAllocationModal = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Customize Detail Modal -->
    <md-dialog :md-active.sync="customizeModal">
      <md-dialog-title>Order Details</md-dialog-title>
      <md-dialog-content :style="{ 'width': '780px' }">
        <div class="modal-details" v-if="orderData && orderData.kidsOrderKidDetails">
          <p><strong>Email:</strong> {{ orderData.kidsOrderKidDetails.email }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.email)">Copy</button>
          </p>
          <p><strong>Child Name:</strong> {{ orderData.kidsOrderKidDetails.childName }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.childName)">Copy</button>
          </p>
          <p><strong>Birth Month:</strong> {{ orderData.kidsOrderKidDetails.birthMonth }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.birthMonth)">Copy</button>
          </p>
          <p><strong>Birth Year:</strong> {{ orderData.kidsOrderKidDetails.birthYear }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.birthYear)">Copy</button>
          </p>
          <p><strong>Required Apps:</strong> {{ orderData.kidsOrderKidDetails.requiredApps }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.requiredApps)">Copy</button>
          </p>
          <p><strong>Personalized Message:</strong> {{ orderData.kidsOrderKidDetails.personalizedMessage }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.personalizedMessage)">Copy</button>
          </p>
          <p><strong>Hear About Us:</strong> {{ orderData.kidsOrderKidDetails.hearAboutUs }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.hearAboutUs)">Copy</button>
          </p>
          <p><strong>Request Callback:</strong> {{ orderData.kidsOrderKidDetails.requestCallback ? 'Yes' : 'No' }}</p>
          <p><strong>Feedback:</strong> {{ orderData.kidsOrderKidDetails.feedback }}
            <button @click="copyToClipboard(orderData.kidsOrderKidDetails.feedback)">Copy</button>
          </p>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="customizeModal = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="qrModal">
      <md-dialog-title>Default Enrollment QR Code</md-dialog-title>
      <md-dialog-content>
        <div class="qr-modal-container">
          <img src="/img/WingioDefaultQrCode.png" class="qr-large" />
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="qrModal = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>


    <!-- Tracking Information Section -->
    <div class="md-layout-item md-size-100" v-if="orderData.carrierName">
      <md-card>
        <md-card-header>
          <div class="title"><b>Tracking Information</b> &nbsp;
            <a href="javascript:void(0)" style="color:blue !important" @click="trackingDetailModal = true"><i class="fas fa-pen"></i></a>
          </div>
        </md-card-header>
        <md-card-content>
          <ul>
            <li v-if="orderData.trackingNumber">Tracking Number: <strong>{{ orderData.trackingNumber }}</strong></li>
            <li v-if="orderData.carrierName">Carrier: <strong>{{ orderData.carrierName }}</strong></li>
            <li v-if="orderData.trackingLink">Tracking Link: <a :href="orderData.trackingLink" target="_blank">{{ orderData.trackingLink }}</a></li>
            <li v-if="orderData.expectedDeliveryDate">Expected Delivery Date: <strong>{{ (orderData.expectedDeliveryDate) }}</strong></li>
            <li v-if="orderData.outForDeliveryAutoUpdateDate">Out for Delivery Date: <strong>{{ (orderData.outForDeliveryAutoUpdateDate) }}</strong></li>
          </ul>
        </md-card-content>
      </md-card>
    </div>

    <!-- Recipient Info + Status -->
    <div class="md-layout-item md-small-size-100 md-medium-size-40">
      <md-card>
        <md-card-header>
          <div class="title"><b>Recipient Information</b></div>
        </md-card-header>
        <md-card-content class="recipient-info">
          <p>Full Name: <strong>{{ orderData.name }}</strong></p>
          <p>Email: <a href="javascript:void(0)" @click="ByPassUserLogin(orderData.email)">{{ orderData.email }}</a></p>
          <p>Phone Number: <strong>{{ orderData.phoneNumber }}</strong></p>
          <p v-if="orderData.address">Address:
            <strong>
              {{ formatAddress(orderData.address.address) }}
            </strong>
          </p>
          <p v-if="orderData.countryCode">
            Market:
            <span class="country-badge" :style="getCountryBadgeStyle(orderData.countryCode)">
              {{ getCountryFlag(orderData.countryCode) }} {{ getCountryName(orderData.countryCode) }} ({{ orderData.countryCode }})
            </span>
          </p>
        </md-card-content>
      </md-card>
    </div>


    <div class="md-layout-item md-small-size-100 md-medium-size-60">
      <md-card>
        <md-card-header>
          <md-card-header>
            <div class="title d-flex justify-content-between align-items-center" style="flex-wrap: wrap;">
              <span>Status</span>
              <div class="d-flex align-items-center">
                <span class="text-success font-weight-bold mr-2">{{ orderData.orderStatus }}</span>
                <md-menu md-size="medium">
                  <md-button class="md-icon-button" md-menu-trigger>
                    <md-icon>arrow_drop_down</md-icon>
                  </md-button>
                  <md-menu-content>
                    <md-menu-item v-if="orderData.orderStatus == 'Confirmed'" @click="trackingDetailModal = true">Shipped</md-menu-item>
                    <md-menu-item v-if="orderData.orderStatus == 'Shipped'" @click="updateStatus('Out For Delivery')">Out For Delivery</md-menu-item>
                    <md-menu-item v-if="orderData.orderStatus == 'Out For Delivery'" @click="updateStatus('Delivered')">Delivered</md-menu-item>
                  </md-menu-content>
                </md-menu>
              </div>
            </div>
          </md-card-header>
        </md-card-header>
        <md-card-content>
          <!-- Service Code + Create Order — only for GB orders (Royal Mail UK only) -->
          <div class="d-flex align-items-center mb-3" style="gap: 16px; flex-wrap: wrap;"
            v-if="!orderData.royalMailOrderId && (orderData.countryCode || 'GB') === 'GB'">
            <md-field class="md-layout-item md-size-30 md-small-size-100">
              <label>Service Code</label>
              <md-input v-model="serviceCode" placeholder="e.g. PFE24"></md-input>
            </md-field>
            <md-button class="md-primary md-dense" :disabled="isDisabled" @click="createRoyalMailOrder()">
              Create Order <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>
          </div>
          <!-- Non-GB Notice -->
          <div v-else-if="!orderData.royalMailOrderId && (orderData.countryCode || 'GB') !== 'GB'" class="non-gb-notice">
            <md-icon style="color: #f57c00;">info</md-icon>
            Royal Mail dispatch is GB-only. Use a different carrier for {{ getCountryName(orderData.countryCode) }} orders.
          </div>
          <div v-else class="order-status-card">
            <md-button class="md-primary md-raised md-dense action-btn" :disabled="isDisabled" @click="getRoyalMailOrder">
              <span v-if="!isDisabled">Get Order Status</span>
              <span v-else><i class="fa fa-spinner fa-spin"></i> Fetching...</span>
            </md-button>
            <div class="order-info" v-if="orderData.royalMailOrderId">
              <div class="info-row">
                <span class="label" :style="{ 'padding': 'unset' }">Royal Mail Order ID</span>
                <span class="value">{{ orderData.royalMailOrderId }}</span>
              </div>
              <div class="info-row">
                <span class="label" :style="{ 'padding': 'unset' }">Royal Mail Order Status</span>
                <span class="value">N/A</span>
              </div>
            </div>
          </div>


          <div class="stepper pt-2">
            <div class="step-item">
              <div class="step active"><md-icon>check_circle</md-icon></div>
              <div class="step-label">Confirmed</div>
            </div>
            <div class="step-line" :class="{ active: ['Shipped', 'Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }"></div>
            <div class="step-item">
              <div class="step" :class="{ active: ['Shipped', 'Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }">
                <md-icon>local_shipping</md-icon>
              </div>
              <div class="step-label">Shipped</div>
              <p class="text-center text-muted mt-2" v-if="orderData.orderStatus == 'Shipped'">{{ HumanReadableDateFormat(orderData.orderStatusLastUpdateDate) }}</p>
            </div>
            <div class="step-line" :class="{ active: ['Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }"></div>
            <div class="step-item">
              <div class="step" :class="{ active: ['Out For Delivery', 'Delivered'].includes(orderData.orderStatus) }">
                <md-icon>two_wheeler</md-icon>
              </div>
              <div class="step-label">Out For Delivery</div>
              <p class="text-center text-muted mt-2" v-if="orderData.orderStatus == 'Out For Delivery'">{{ HumanReadableDateFormat(orderData.orderStatusLastUpdateDate) }}</p>
            </div>
            <div class="step-line" :class="{ active: orderData.orderStatus === 'Delivered' }"></div>
            <div class="step-item">
              <div class="step" :class="{ active: orderData.orderStatus === 'Delivered' }">
                <md-icon>done_all</md-icon>
              </div>
              <div class="step-label">Delivered</div>
              <p class="text-center text-muted mt-2" v-if="orderData.orderStatus == 'Delivered'">{{ HumanReadableDateFormat(orderData.orderStatusLastUpdateDate) }}</p>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <!-- Products Table -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <h4 class="title">Products</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="products" table-header-color="green">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name">
                {{ item.prductName }} <span v-if="item.selectedColorVariant"><b> - {{ item.selectedColorVariant }}</b></span>
              </md-table-cell>
              <md-table-cell md-label="Qty">
                <span v-if="item.productType != 'recurring'">1</span>
                <span v-else>{{ item.qty }}</span>
              </md-table-cell>
              <md-table-cell md-label="Unit Price">{{ orderCurrencySymbol }}{{ item.price }}</md-table-cell>
              <md-table-cell md-label="Total">{{ orderCurrencySymbol }}{{ item.totalPrice }}</md-table-cell>
              <md-table-cell md-label="Serial Number">
                <span v-if="item.serialNumber">{{ item.serialNumber }}</span>
                <span v-else>-</span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <!-- Payment Info -->
    <div class="md-layout-item md-small-size-100 md-medium-size-50">
      <md-card>
        <md-card-header>
          <div class="title">
            Payment Information
            <span v-if="orderData.currency" class="currency-pill-sm">
              {{ (orderData.currency || '').toUpperCase() }}
            </span>
          </div>
        </md-card-header>
        <md-card-content>
          <p>Order Total: <span class="float-right">{{ orderCurrencySymbol }}{{ orderData.orderTotal }}</span></p>
          <p>Discount: <span class="float-right">{{ orderCurrencySymbol }}{{ orderData.discountAmount }}</span></p>
          <p v-if="orderData.discountCode">
            Discount Code:
            <span class="float-right">{{ orderData.discountCode }}</span>
          </p>
          <p>
            Shipping Fee ({{ orderData.shippingDetail ? orderData.shippingDetail.label : "Free" }}):
            <span class="float-right">{{ orderCurrencySymbol }}{{ orderData.shippingAmount }}</span>
          </p>
          <p>Tax: <span class="float-right">{{ orderCurrencySymbol }}{{ orderData.taxAmount }}</span></p>
          <hr />
          <p class="total">Payable Total: <span class="float-right font-weight-bold">{{ orderCurrencySymbol }}{{ orderData.payableAmount }}</span></p>
        </md-card-content>
      </md-card>
    </div>

    <!-- Referral Information Section (if applicable) -->
    <div class="md-layout-item md-small-size-100 md-medium-size-50" v-if="orderData.usedReferralCode">
      <md-card>
        <md-card-header>
          <div class="title">
            <md-icon class="referral-icon">card_giftcard</md-icon>
            Referral Discount Applied
          </div>
        </md-card-header>
        <md-card-content>
          <p>
            <strong>Referral Code:</strong> 
            <span class="referral-code-badge">{{ orderData.usedReferralCode }}</span>
            <button class="copy-btn" @click="copyToClipboard(orderData.usedReferralCode)">
              <md-icon>content_copy</md-icon>
            </button>
          </p>
          <p>
            <strong>Discount Applied:</strong> 
            <span class="discount-value">{{ orderData.referralDiscountPercent }}%</span>
          </p>
          <p class="savings-highlight">
            <md-icon class="savings-icon">savings</md-icon>
            You saved {{ orderCurrencySymbol }}{{ orderData.referralDiscountAmount }} with this referral!
          </p>
        </md-card-content>
      </md-card>
    </div>


    <!-- Email History Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title">Email History</div>
        </md-card-header>
        <md-card-content>
          <ul v-if="orderData.emailHistory && orderData.emailHistory.length > 0">
            <li v-for="(email, index) in orderData.emailHistory" :key="index" class="email-history-item">
              <div class="email-subject">
                <strong>{{ email.subject }}: </strong>
                <span class="email-time">{{ HumanReadableDateFormat(email.sentAt) }}</span>
              </div>
              <div v-if="email.isEmailSent" class="email-success">
                <span class="icon success">✔️</span> Email sent successfully.
              </div>
              <div v-else class="email-error">
                <span class="icon error">❌</span> <strong>Error:</strong> {{ email.message }}
              </div>
            </li>
          </ul>
          <span v-else>No email history record found.</span>
        </md-card-content>
      </md-card>
    </div>

    <!-- Order Audit History Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title"><b>Order Audit History</b></div>
        </md-card-header>
        <md-card-content>
          <div v-if="orderData.auditHistory && orderData.auditHistory.length === 0">
            <p>No audit history available.</p>
          </div>
          <ul v-if="orderData.auditHistory && orderData.auditHistory.length > 0">
            <li v-for="(entry, index) in orderData.auditHistory" :key="index">
              <strong>{{ entry.action }}</strong> - <span>{{ HumanReadableDateFormat(entry.date) }}</span>
            </li>
          </ul>
        </md-card-content>
      </md-card>
    </div>

    <!-- Order Notes Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title"><b>Order Notes</b></div>
        </md-card-header>
        <md-card-content>
          <div v-if="!orderData.orderNotes || orderData.orderNotes.length === 0">
            <p>No notes available for this order.</p>
          </div>
          <ul v-if="orderData.orderNotes && orderData.orderNotes.length > 0" class="order-notes-list">
            <li v-for="(note, index) in orderData.orderNotes" :key="index" class="order-note-item">
              <div class="note-content">
                <strong>Note {{ index + 1 }}:</strong>
                <p>{{ note }}</p>
              </div>
              <md-button class="md-icon-button delete-button" @click="deleteNote(index)">
                <md-icon>delete</md-icon>
              </md-button>
            </li>
          </ul>
          <md-button class="md-raised md-primary" @click="addNewNote">Add Note</md-button>
          <div v-for="(note, index) in newNotes" :key="index" class="new-note-box">
            <md-textarea v-model="newNotes[index]" label="Enter note here..." rows="1" outlined style="width: 100%;"></md-textarea>
            <md-button class="md-icon-button" @click="deleteNewNote(index)">
              <md-icon>delete</md-icon>
            </md-button>
          </div>
          <md-button class="md-raised md-primary" @click="saveNotes">Save Notes</md-button>
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </md-card-content>
      </md-card>
    </div>


    <!-- Past Orders Section -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header>
          <div class="title"><b>Past Orders</b></div>
        </md-card-header>
        <md-card-content>
          <div v-if="pastOrders.length == 0">
            <p>No past orders found.</p>
          </div>
          <div class="md-layout-item md-size-100">
            <md-card>
              <md-card-content>
                <md-layout v-if="pastOrders.length > 0" class="md-gutter-md">
                  <md-layout-item v-for="orderItem in pastOrders" :key="orderItem.orderNumber" class="md-size-100" :style="{ margin: '1px !important' }">
                    <md-card>
                      <md-card-header>
                        <div class="title">
                          Order #{{ orderItem.orderNumber }}
                          <span v-if="orderItem.countryCode" class="country-badge-sm" :style="getCountryBadgeStyle(orderItem.countryCode)">
                            {{ getCountryFlag(orderItem.countryCode) }} {{ orderItem.countryCode }}
                          </span>
                        </div>
                      </md-card-header>
                      <md-card-content>
                        <p style="margin-bottom: 1px;"><strong>Date:</strong> {{ (orderItem.created_at) }}</p>
                        <p style="margin-bottom: 1px;"><strong>Status:</strong> <span :class="statusClass(orderItem.orderStatus)">{{ orderItem.orderStatus }}</span></p>
                        <p style="margin-bottom: 1px;"><strong>Total:</strong> {{ getCurrencySymbol(orderItem.currency) }}{{ orderItem.orderTotal }}</p>
                        <md-button class="md-primary" @click="$router.push({ path: 'order-detail', query: { id: orderItem._id }})">View Order</md-button>
                      </md-card-content>
                    </md-card>
                  </md-layout-item>
                </md-layout>
              </md-card-content>
            </md-card>
          </div>
        </md-card-content>
      </md-card>
    </div>


    <!-- Update Tracking Detail Modal -->
    <template>
      <modal v-if="trackingDetailModal" @close="trackingDetailModal = false">
        <template slot="header">
          <h4 class="modal-title">Update Tracking Detail</h4>
          <md-button style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
            @click="trackingDetailModal = false"><md-icon>clear</md-icon></md-button>
        </template>
        <template slot="body">
          <div class="box-body">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <md-field><label>Tracking Number</label>
                  <md-input type="text" v-model="trackingNumber"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field><label>Tracking Link</label>
                  <md-input type="url" v-model="trackingLink"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field><label>Carrier Name</label>
                  <md-input type="text" v-model="carrierName"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>
                    Auto Update to Out For Delivery After (Days)
                  </label>

                  <md-input
                    type="number"
                    min="1"
                    v-model="autoOutForDeliveryDays"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100">
                <md-field><label>Expected Delivery Date</label>
                  <md-input type="text" v-model="expectedDeliveryDate"></md-input>
                </md-field>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-danger md-simple" @click="trackingDetailModal = false">Close</md-button>
          <md-button class="md-success mt-1" type="submit" :disabled="isDisabled" @click="updateStatus('Shipped')">Save
            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </template>
      </modal>
    </template>

    <!-- Device Allocate Modal -->
    <template>
      <modal v-if="allocateDeviceModal" @close="allocateDeviceModal = false">
        <template slot="header">
          <h4 class="modal-title">Allocate Device</h4>
          <md-button style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
            @click="allocateDeviceModal = false"><md-icon>clear</md-icon></md-button>
        </template>
        <template slot="body">
          <div class="box-body">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Serial Number</label>
                  <md-input type="text" v-model="searchQuery" placeholder="Search serial number"></md-input>
                  <select id="serialNumberdropdown" v-model="serialNumber" :style="{ width: '100%' }" @change="getProfileDetail()">
                    <option v-for="serialnumber in filteredSerialNumbers" :key="serialnumber" :value="serialnumber">
                      {{ serialnumber }}
                    </option>
                  </select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field><label>Kid Name</label>
                  <md-input type="text" v-model="kidName" :disabled="kidNameDisabled"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50" v-if="deviceAllotmentQrCode">
                <img :src="deviceAllotmentQrCode" height="150px" />
              </div>
              <div class="md-layout-item md-size-100" v-if="deviceAllocationList.length > 0">
                <h4><b>Existing Allocation of serial number {{ serialNumber }}</b></h4>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Profile Name</th>
                      <th scope="col">Parent Email</th>
                      <th scope="col">Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="profile in deviceAllocationList" :key="profile._id">
                      <td>{{ profile.profileName }}</td>
                      <td>{{ profile.email }}</td>
                      <td>{{ profile.createdAt }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-danger mt-1 mr-2" @click="allocateDeviceModal = false">Close</md-button>
          <md-button class="md-success mt-1" type="submit" :disabled="isDisabled" @click="allocateDevice()">
            Allocate <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </template>
      </modal>
    </template>
  </div>
</template>

<script>
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";
import { Modal } from "@/components";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";

const COUNTRY_META = {
  GB: { flag: '🇬🇧', name: 'United Kingdom', bg: '#e3f2fd', color: '#0d47a1', border: '#90caf9' },
  DE: { flag: '🇩🇪', name: 'Germany',        bg: '#fff3e0', color: '#e65100', border: '#ffb74d' },
  FR: { flag: '🇫🇷', name: 'France',         bg: '#f3e5f5', color: '#4a148c', border: '#ce93d8' },
  US: { flag: '🇺🇸', name: 'United States',  bg: '#e8f5e9', color: '#1b5e20', border: '#a5d6a7' },
  IE: { flag: '🇮🇪', name: 'Ireland',        bg: '#e0f2f1', color: '#004d40', border: '#80cbc4' },
  ES: { flag: '🇪🇸', name: 'Spain',          bg: '#fce4ec', color: '#880e4f', border: '#f48fb1' },
  IT: { flag: '🇮🇹', name: 'Italy',          bg: '#f1f8e9', color: '#33691e', border: '#aed581' },
  NL: { flag: '🇳🇱', name: 'Netherlands',    bg: '#fff8e1', color: '#ff6f00', border: '#ffd54f' },
  BE: { flag: '🇧🇪', name: 'Belgium',        bg: '#efebe9', color: '#3e2723', border: '#bcaaa4' },
  PT: { flag: '🇵🇹', name: 'Portugal',       bg: '#e8eaf6', color: '#1a237e', border: '#9fa8da' },
  PL: { flag: '🇵🇱', name: 'Poland',         bg: '#fbe9e7', color: '#bf360c', border: '#ffab91' },
  AT: { flag: '🇦🇹', name: 'Austria',        bg: '#fafafa', color: '#212121', border: '#bdbdbd' },
  SE: { flag: '🇸🇪', name: 'Sweden',         bg: '#fffde7', color: '#f57f17', border: '#fff176' },
  DK: { flag: '🇩🇰', name: 'Denmark',        bg: '#ffebee', color: '#b71c1c', border: '#ef9a9a' },
  FI: { flag: '🇫🇮', name: 'Finland',        bg: '#e1f5fe', color: '#01579b', border: '#81d4fa' },
};

const CURRENCY_SYMBOLS = {
  GBP: '£', EUR: '€', USD: '$', SEK: 'kr', DKK: 'kr', NOK: 'kr',
  CHF: 'Fr', PLN: 'zł', CZK: 'Kč', HUF: 'Ft', AUD: 'A$', CAD: 'C$',
};


export default {
  name: "OrderDetail",
  components: { Modal },
  data() {
    const deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + 3);
      
      // Format in UK style: "10 May 2026" or "10th May 2026"
    const formattedDate = deliveryDate.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    return {
      id: this.$route.query.id,
      orderData: {},
      products: [],
      trackingDetailModal: false,
      trackingNumber: "",
      trackingLink: "",
      carrierName: "Royal Mail",
      expectedDeliveryDate: formattedDate,
      isDisabled: false,
      allocateDeviceModal: false,
      serialNumber: "",
      subscriptionCode: "",
      kidName: "Kid 1",
      kidNameDisabled: false,
      autoOutForDeliveryDays: 1,
      pastOrders: [],
      searchQuery: "",
      availableSerialNumbers: [],
      newNotes: [],
      errorMessage: '',
      deviceAllocationList: [],
      qrModal: false,
      deviceAllotmentQrCode: "",
      customizeModal: false,
      deviceAllocationModal: false,
      serviceCode: "TOLP24",
    };
  },
  computed: {
    filteredSerialNumbers() {
      const query = this.searchQuery.toLowerCase();
      return this.availableSerialNumbers.filter((serialNumber) =>
        serialNumber.toLowerCase().includes(query)
      );
    },
    // Returns the currency symbol for the current order — used everywhere
    orderCurrencySymbol() {
      return this.getCurrencySymbol(this.orderData?.currency);
    },
  },
  methods: {
    // ── Country / Currency Helpers ─────────────────────────────────────
    getCountryFlag(code) {
      const c = (code || 'GB').toUpperCase();
      return COUNTRY_META[c] ? COUNTRY_META[c].flag : '🌍';
    },
    getCountryName(code) {
      const c = (code || 'GB').toUpperCase();
      return COUNTRY_META[c] ? COUNTRY_META[c].name : code;
    },
    getCountryBadgeStyle(code) {
      const c = (code || 'GB').toUpperCase();
      const meta = COUNTRY_META[c] || { bg: '#eee', color: '#333', border: '#ccc' };
      return {
        backgroundColor: meta.bg,
        color: meta.color,
        border: `1px solid ${meta.border}`,
      };
    },
    getCurrencySymbol(currency) {
      if (!currency) return '£';
      return CURRENCY_SYMBOLS[currency.toUpperCase()] || (currency.toUpperCase() + ' ');
    },

    statusClass(status) {
      switch (status) {
        case "Confirmed":        return "badge badge-success";
        case "Shipped":          return "badge badge-primary";
        case "Out For Delivery": return "badge badge-warning";
        case "Delivered":        return "badge badge-info";
        default:                 return "";
      }
    },
    orderDetail() {
      let data = { id: this.id };
      OrdersDataService.orderDetail(data)
        .then((response) => {
          this.orderData = response.data.data;
          this.products = this.orderData.orderItemDetail;
          this.availableSerialNumbers = this.orderData.baseDevicesSerialNumber;
          this.pastOrders = this.orderData.pastOrders;
          this.trackingNumber = this.orderData.trackingNumber;
          this.trackingLink = this.orderData.trackingLink;
          if (this.orderData.carrierName) this.carrierName = this.orderData.carrierName;
          //this.expectedDeliveryDate = this.orderData.expectedDeliveryDate;
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateStatus(orderStatus) {
      this.isDisabled = true;
      let data = {
        id: this.id, orderStatus, trackingNumber: this.trackingNumber,
        trackingLink: this.trackingLink, carrierName: this.carrierName,
        expectedDeliveryDate: this.expectedDeliveryDate, autoOutForDeliveryDays: this.autoOutForDeliveryDays
      };
      OrdersDataService.updateStatus(data)
        .then((response) => {
          this.isDisabled = false;
          this.trackingDetailModal = false;
          this.$toast.success(response.data.respones_msg);
          this.orderDetail();
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    openAllocateDeviceModal(subscriptionCode, itemId, serialNumber = null) {
      this.subscriptionCode = subscriptionCode;
      this.orderItemId = itemId;
      if (serialNumber) {
        this.availableSerialNumbers.push(serialNumber);
        this.serialNumber = serialNumber;
      }
      this.allocateDeviceModal = true;
    },
    getProfileDetail() {
      this.kidNameDisabled = true;
      this.isDisabled = true;
      let data = {
        serialNumber: this.serialNumber, email: this.orderData.email,
        subscriptionCode: this.subscriptionCode, kidName: this.kidName,
        orderData: this.orderData, orderItemId: this.orderItemId,
      };
      OrdersDataService.getProfileDetail(data)
        .then((response) => {
          this.deviceAllotmentQrCode = response.data.deviceAllotmentQrCode;
          this.deviceAllocationList = response.data.deviceAllocationList;
          if (response.data.data) this.kidName = response.data.data;
          this.kidNameDisabled = false;
          this.isDisabled = false;
        }).catch((e) => {
          this.kidNameDisabled = false;
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    allocateDevice() {
      if (!this.kidName) return this.$toast.error("Enter kid name.");
      let data = {
        serialNumber: this.serialNumber, email: this.orderData.email,
        subscriptionCode: this.subscriptionCode, kidName: this.kidName,
        orderData: this.orderData, orderItemId: this.orderItemId,
      };
      OrdersDataService.allocateDevice(data)
        .then((response) => {
          this.allocateDeviceModal = false;
          this.$toast.success(response.data.respones_msg);
          this.orderDetail();
          this.serialNumber = "";
          this.allocateDeviceModal = false;
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    formatAddress(address) {
      if (!address) return '';
      const parts = [
        address.line1, address.line2, address.city,
        address.state, address.country, address.postal_code,
      ].filter(Boolean);
      return parts.join(', ');
    },
    addNewNote() { this.newNotes.push(''); },
    deleteNote(index) { this.orderData.orderNotes.splice(index, 1); },
    deleteNewNote(index) { this.newNotes.splice(index, 1); },
    async saveNotes() {
      if (this.newNotes.some(note => !note.trim())) {
        this.errorMessage = 'All notes must be filled!';
        return;
      }
      const updatedNotes = [
        ...(this.orderData.orderNotes || []),
        ...(this.newNotes || []),
      ];
      let data = { updatedNotes, id: this.id };
      OrdersDataService.updateNotes(data)
        .then((response) => {
          this.newNotes = [];
          this.$toast.success(response.data.respones_msg);
          this.orderDetail();
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    createRoyalMailOrder() {
      this.isDisabled = true;
      let data = { id: this.orderData._id, serviceCode: this.serviceCode };
      OrdersDataService.createRoyalMailOrder(data)
        .then((response) => {
          this.orderDetail();
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    getRoyalMailOrder() {
      this.isDisabled = true;
      let data = { id: this.orderData._id };
      OrdersDataService.getRoyalMailOrder(data)
        .then((response) => {
          this.orderDetail();
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    ByPassUserLogin(email, portal = "") {
      let data = { email };
      UsersDataService.ByPassUserLogin(data)
        .then((response) => {
          if (portal == "MDM") {
            localStorage.setItem('token', response.data.data.token);
            let routeData = this.$router.resolve({ name: 'dashboard' });
            window.open(routeData.href, '_blank');
          } else {
            window.open("https://parent.mywingio.com?token=" + response.data.data.token, '_blank');
          }
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    openQrModal() { this.qrModal = true; },
    openCustomizeDetailModal() { this.customizeModal = true; },
    openDeviceAllocationModal() { this.deviceAllocationModal = true; },
    copyToClipboard(text) {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$toast.success("Copied to clipboard!");
    },
    clearData() {
      this.isDisabled = true;
      let data = { id: this.id };
      OrdersDataService.clearDeviceConfigurationData(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
    this.orderDetail();
  },
};
</script>

<style scoped>
.stepper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 10px;
}
.step-item { display: flex; flex-direction: column; align-items: center; min-width: 80px; text-align: center; }
.step {
  width: 40px; height: 40px; background: #e0e0e0; border-radius: 50%;
  display: flex; justify-content: center; align-items: center;
  color: white; font-size: 20px; z-index: 1;
}
.step.active { background: #4caf50; }
.step-line {
  flex: 1; height: 4px; background-color: #e0e0e0;
  margin: 18px 5px 0; border-radius: 2px; position: relative; z-index: 0;
}
.step-line.active { background-color: #4caf50; }
.step-label { margin-top: 6px; font-size: 12px; color: #333; }
.product-img { width: 30px; height: 30px; border-radius: 4px; object-fit: cover; }
.total { font-weight: 600; }
.md-layout-item { margin-bottom: 12px !important; }
.md-card { margin: 0 !important; }
.md-card-header, .md-card-content { padding-top: 8px; padding-bottom: 8px; }
.recipient-info p { margin-bottom: 4px; }

.email-history-item {
  padding: 10px 0; display: flex; flex-direction: column;
  margin-bottom: 15px; border-bottom: 1px solid #f0f0f0;
}
.email-history-item:not(:last-child) { border-bottom: 1px solid #f0f0f0; }
.new-note-box { margin-bottom: 10px; display: flex; align-items: center; }
md-textarea { width: 100%; margin-right: 10px; }
.error-message { color: red; font-size: 0.9rem; margin-top: 10px; }
.order-notes-list { list-style-type: none; padding: 0; }
.order-note-item {
  background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 4px;
  margin-bottom: 10px; padding: 10px;
  display: flex; align-items: center; justify-content: space-between;
}
.order-note-item .note-content { flex-grow: 1; }
.order-note-item p { margin: 5px 0; font-size: 1rem; color: #333; }
.delete-button { margin-left: 10px; background-color: #f44336; color: white; }
.delete-button md-icon { font-size: 20px; }
.md-raised { background-color: #3f51b5; color: white; }
.md-raised:hover { background-color: #303f9f; }

.order-header {
  display: flex; align-items: center; justify-content: space-between;
}
.order-info-header h6 { margin: 4px 0; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.button-group { display: flex; align-items: center; gap: 10px; }

.qr-modal-container { display: flex; justify-content: center; padding: 10px 0; }
.qr-large {
  height: 260px; border: 1px solid #ccc; border-radius: 8px;
  background: #fff; padding: 8px;
}
.order-status-card {
  background: #fff; border-radius: 8px; padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); max-width: 420px;
}
.action-btn { width: 100%; margin-bottom: 16px; }
.order-info { border-top: 1px solid #eee; padding-top: 12px; }
.info-row { display: flex; justify-content: space-between; align-items: center; }
.label { color: #777; font-size: 13px; }
.value { font-weight: 600; color: #333; word-break: break-all; }

/* ── New: Country & currency styling ───────────────────────────────── */
.country-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;
  margin-left: 6px;
}
.country-badge-sm {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  margin-left: 8px;
  vertical-align: middle;
}
.currency-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  color: #555;
  font-size: 11px;
  font-weight: 600;
  margin-left: 6px;
  vertical-align: middle;
}
.currency-pill-sm {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 8px;
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
  font-size: 10px;
  font-weight: 600;
  margin-left: 8px;
}
.non-gb-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background-color: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  color: #6d4c41;
  font-size: 13px;
  margin-bottom: 12px;
}

/* ── Referral Information Styling ────────────────────────────────── */
.referral-icon {
  color: #9c27b0;
  margin-right: 8px;
  vertical-align: middle;
}

.referral-code-badge {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.5px;
  margin-left: 8px;
}

.copy-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  vertical-align: middle;
  color: #666;
  transition: color 0.2s;
}

.copy-btn:hover {
  color: #333;
}

.copy-btn .md-icon {
  font-size: 18px;
}

.discount-value {
  color: #4caf50;
  font-weight: 700;
  font-size: 16px;
}

.savings-highlight {
  background-color: #e8f5e9;
  border-left: 4px solid #4caf50;
  padding: 10px 12px;
  border-radius: 4px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2e7d32;
  font-weight: 600;
}

.savings-icon {
  color: #4caf50;
  font-size: 20px;
}
</style>